// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Container } from 'react-bootstrap';
import Layout from 'components/Layout';
import SEO from 'components/seo';
import {
  SPageContainer,
  SContainer,
  SPageTitleLink,
  SPageSlug,
  SH1,
} from './styles';
import { ucFirst } from 'utils/ucFirst';
import useBlogTagsData from '../../../pageDataHooks/useBlogTagsData';

const Tags = () => {
  const { contentfulPage: data, allWpTag } = useBlogTagsData();
  const edges = allWpTag.edges;

  return (
    <Layout>
      <SEO
        useTitleTemplate={false}
        description={data.metaDescription.metaDescription}
        title={data.metaTitle}
      />
      <SContainer>
        <Container>
          <SH1>Blog Tags</SH1>
          <SPageContainer>
            {edges.map(edge => {
              return (
                <section key={edge.node.name}>
                  <SPageTitleLink>
                    <Link to={`/blog/tags/${edge.node.slug}/1/`}>
                      {ucFirst(edge.node.name)}
                    </Link>
                  </SPageTitleLink>
                  <SPageSlug>{edge.node.description}</SPageSlug>
                </section>
              );
            })}
          </SPageContainer>
        </Container>
      </SContainer>
    </Layout>
  );
};

Tags.propTypes = {
  data: PropTypes.object,
};

export default Tags;
